import {
  parseAsArrayOf,
  parseAsBoolean,
  parseAsIndex,
  parseAsInteger,
  parseAsString,
  parseAsStringLiteral,
  useQueryStates,
} from 'nuqs';
import { DirectionType } from 'types';

export const useTransactionTypesSearch = () => {
  const defaultSearchParams = {
    name: '',
    type: '',
    discontinued: false,
    page: 0,
    size: 100,
    sort: ['id'],
    direction: ['DESC'] as DirectionType[],
  };

  const [searchParams, setSearchParams] = useQueryStates({
    name: parseAsString.withDefault(defaultSearchParams.name),
    type: parseAsString.withDefault(defaultSearchParams.type),
    discontinued: parseAsBoolean.withDefault(defaultSearchParams.discontinued),
    page: parseAsIndex.withDefault(defaultSearchParams.page),
    size: parseAsInteger.withDefault(defaultSearchParams.size),
    sort: parseAsArrayOf(parseAsString).withDefault(defaultSearchParams.sort),
    direction: parseAsArrayOf(parseAsStringLiteral(['ASC', 'DESC'] as const)).withDefault(
      defaultSearchParams.direction
    ),
  });

  return {
    searchParams,
    defaultSearchParams,
    setSearchParams,
  };
};
